var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex flex-column wrapper" }, [
    _c("div", { staticClass: "d-flex justify-content-between mb-1" }, [
      _c("div", [
        _c("span", [
          _vm._v("\n        " + _vm._s(_vm.headerTitle) + "\n      ")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "text-secondary-light" }, [
          _vm._v("\n        (" + _vm._s(_vm.headerSubTitle) + ")\n      ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex", staticStyle: { gap: "10px" } },
        _vm._l(_vm.links, function(link, index) {
          return _vm.accountMapping[link.ref].items.length > 0
            ? _c(
                "button",
                {
                  key: index,
                  staticClass: "btn btn-sm btn-light",
                  staticStyle: { height: "29px" },
                  on: {
                    click: function($event) {
                      return link.onClick(link)
                    }
                  }
                },
                [
                  _vm._v("\n        " + _vm._s(link.text) + "\n        "),
                  _c("i", { staticClass: "fas fa-link" })
                ]
              )
            : _vm._e()
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "lines mb-1" }, [
      _c("div", { staticClass: "main-item" }, [
        _c("span", [_vm._v("\n        " + _vm._s(_vm.itemTitle) + "\n      ")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "debit-credit" }, [
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "span",
            {
              staticClass: "text-secondary-light w-50",
              class: [],
              staticStyle: { "padding-left": "12px" }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("apps.accounting.journal_mapping.debit")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "text-secondary-light w-50",
              class: [],
              staticStyle: { "padding-left": "12px" }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("apps.accounting.journal_mapping.credit")) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-column" },
      _vm._l(_vm.form.items, function(item, index) {
        return !item.hide
          ? _c("div", { key: index, staticClass: "lines mb-2" }, [
              _c("div", { staticClass: "main-item" }, [
                _c("input", {
                  staticClass: "form-control text-select-all",
                  staticStyle: {
                    "border-right": "none",
                    "border-radius": ".25rem 0 0 .25rem"
                  },
                  attrs: { disabled: true, type: "text" },
                  domProps: { value: item.text }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "debit-credit" }, [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("BaseDropdown", {
                      staticStyle: { "border-radius": "0" },
                      attrs: {
                        options: _vm.accountOptions,
                        disabled:
                          _vm.disabledDebit || item.debit_account_disabled
                      },
                      model: {
                        value: item.debit_account,
                        callback: function($$v) {
                          _vm.$set(item, "debit_account", $$v)
                        },
                        expression: "item.debit_account"
                      }
                    }),
                    _vm._v(" "),
                    _c("BaseDropdown", {
                      attrs: {
                        options: _vm.accountOptions,
                        disabled:
                          _vm.disabledCredit || item.credit_account_disabled
                      },
                      model: {
                        value: item.credit_account,
                        callback: function($$v) {
                          _vm.$set(item, "credit_account", $$v)
                        },
                        expression: "item.credit_account"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f100de02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f100de02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/AccountMapping.vue
// module id = null
// module chunks = 